export default function isCVLinens() {
  const url = (window.location.href || '').toLowerCase();
  return url.includes('cvlinens');
}
